import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44d582c8")

_pushScopeId("data-v-44d582c8")
const _hoisted_1 = { class: "fridgefetailscoolingassistsettingsitem" }
const _hoisted_2 = { class: "fridgefetailscoolingassistsettingsitem-contents" }
const _hoisted_3 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents" }
const _hoisted_4 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-top" }
const _hoisted_5 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-top-description" }
const _hoisted_6 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-top-description-text" }
const _hoisted_7 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-title" }
const _hoisted_8 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-title-text" }
const _hoisted_9 = { class: "fridgefetailscoolingassistsettingsitem-contents-ocntents-drum" }
const _hoisted_10 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-note" }
const _hoisted_11 = { class: "fridgefetailscoolingassistsettingsitem-contents-contents-note-text" }
const _hoisted_12 = { class: "fridgefetailscoolingassistsettingsitem-bottom" }
const _hoisted_13 = { class: "fridgefetailscoolingassistsettingsitem-bottom-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsDrumPicker = _resolveComponent("FridgeDetailsDrumPicker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.descriptionText), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.contentsTitleText), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_FridgeDetailsDrumPicker, {
            minutesLowerLimit: _ctx.minMinutes,
            minutesUpperLimit: _ctx.maxMinutes,
            initialMinutes: _ctx.initialMinutes,
            isValidSeconds: _ctx.isSecondsValid,
            secondsLowerLimit: _ctx.minSeconds,
            secondsUpperLimit: _ctx.maxSeconds,
            initialSeconds: _ctx.initialSeconds,
            onSelectTime: _ctx.selectTime
          }, null, 8, ["minutesLowerLimit", "minutesUpperLimit", "initialMinutes", "isValidSeconds", "secondsLowerLimit", "secondsUpperLimit", "initialSeconds", "onSelectTime"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.note), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", {
        class: "fridgefetailscoolingassistsettingsitem-bottom-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.okButtonAction(...args))),
        onTouchStart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
        onTouchMove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
        onTouchEnd: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args)))
      }, [
        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.okButtonText), 1)
      ], 32)
    ])
  ]))
})